import _ from 'lodash'
import { diff } from '../lib/render-object'
import codeService from 'data/codes'

const mapper = (text) => {
  return {
    'approles': 'Application Roles',
    'defaultportfolios': 'Default Portfolios',
  }[text] || _.startCase(text)
}

const filterKeys = (obj) => obj && _.pick(obj, ['code', 'users', 'name'])

const alwaysKeep = ['code']

type UserGroupChange = {
  original?: object
  usergroup: object
}

const addUsers = (obj) => {
  if (!obj) return obj
  const codes = codeService.value()
  obj.users = _.map(obj.users, id => _.find(codes['users'], {id})?.code || id)
  return obj
}

export const diffif = (props) => {
  if (props.resource !== 'usergroup') return null

  return () => {
    const change = JSON.parse(props.change)
    const original = addUsers(filterKeys(change?.original))
    const usergroup = props.method == 'DELETE' ? {} : addUsers(filterKeys(change?.usergroup))
    const diffs = diff(original, usergroup, mapper, alwaysKeep)

    const atRest = 
      props.method == 'POST' ? 'Created User Group' : 
      props.method == 'DELETE' ? 'Deleted User Group' : 
      'User Group Change'

    return {diffs, atRest, ...props}
  }
}
